import Unstructured from './Unstructured.js';

export default class SearchInteraction extends Unstructured {
  constructor(snowplow) {
    super(snowplow);
    this._searchFilters = {};
  }

  setSearchFilters(searchFilters) {
    this._searchFilters = searchFilters;
  }

  trackInteraction(field, values) {
    this._searchFilters[field] = values;
    this.setData(field, values, this._searchFilters);
    this.send();
  }

  setData(field, values, searchFilter) {
    this._pushEventData({
      schema: 'iglu:uk.co.netdirector.snowplow/search_interaction_unstructured_event/jsonschema/2-1-0',
      data: {
        interaction: { field, values },
        search_filter: searchFilter
      }
    });
  }
}
